import { workloadToDisplay } from '@/components/Workload/workloadHelpers';

function addStatsPercents(stats, total) {
  if (! total) return null;
  Object.keys(stats).forEach((id) => {
    if (stats[id].number) {
      stats[id].percent = stats[id].number / total * 100;
    } else {
      delete stats[id];
    }
  });
  return stats;
}

export function buildActionStats(elements = []) {
  const stats = {
    finished: { label: 'PROJECT_SHEET.FINISHED', class: 'bg-successgreen', number: 0 },
    urgent: { label: 'PROJECT_SHEET.URGENT', class: 'bg-warningorange', number: 0 },
    overdue: { label: 'PROJECT_SHEET.OVERDUE', class: 'bg-errorred', number: 0 },
    future: { label: 'PROJECT_SHEET.FUTURE', class: 'bg-midgrey', number: 0 },
  };
  elements.forEach((el) => {
    if (! el.getChecklist() || ! el.hasDates()) return;
    el.getChecklist().forEach((action) => {
      const color = el.getChecklistItemColor(action);
      if (action.checked) {
        stats.finished.number++;
      } else if (color === 'errorred') {
        stats.overdue.number++;
      } else if (color === 'warningorange') {
        stats.urgent.number++;
      } else {
        stats.future.number++;
      }
    });
  });
  const total = stats.finished.number + stats.urgent.number + stats.overdue.number + stats.future.number;
  return { total, items: addStatsPercents(stats, total) };
}

export function buildWorkloadStats(elements = []) {
  let estimated = 0;
  let used = 0;

  elements.forEach((el) => {
    if (! el.getChecklist() || ! el.hasDates()) return;
    el.getChecklist().forEach((action) => {
      used += workloadToDisplay(action.workload_used || 0);
      estimated += workloadToDisplay(action.workload || action.workload_used || 0);
    });
  });

  estimated = Math.round(estimated * 100) / 100;
  used = Math.round(used * 100) / 100;
  if (! estimated && ! used) return { total: 0, items: null };

  const remaining = Math.round((estimated - used) * 100) / 100;
  const stats = {
    used: { label: 'PROJECT_SHEET.DAYS_USED', class: 'bg-successgreen', number: Math.min(used, estimated) },
    remaining: { label: 'PROJECT_SHEET.DAYS_REMAINING', class: 'bg-midgrey', number: Math.max(0, remaining) },
    exceeded: { label: 'PROJECT_SHEET.DAYS_EXCEEDED', class: 'bg-errorred', number: Math.max(0, -remaining) },
  };
  const percentTotal = estimated || used;
  return { total: Math.max(estimated, used), items: addStatsPercents(stats, percentTotal) };
}

export function buildBubbleStats(elements = []) {
  const stats = {
    finished: { label: 'PROJECT_SHEET.FINISHED', class: 'bg-successgreen', number: 0 },
    inprogress: { label: 'PROJECT_SHEET.IN_PROGRESS', class: 'bg-warningorange', number: 0 },
    overdue: { label: 'PROJECT_SHEET.OVERDUE', class: 'bg-errorred', number: 0 },
    future: { label: 'PROJECT_SHEET.FUTURE', class: 'bg-midgrey', number: 0 },
  };
  elements.forEach((el) => {
    if (! el.isType('task') || ! el.hasDates()) return;
    let id;
    if (el.getProgress() == 100) {
      id = 'finished';
    } else if (el.getEndTime().isBefore()) {
      id = 'overdue';
    } else if (el.getStartTime().isAfter()) {
      id = 'future';
    } else {
      id = 'inprogress';
    }
    stats[id].number++;
  });
  const total = stats.finished.number + stats.inprogress.number + stats.overdue.number + stats.future.number;
  return { total, items: addStatsPercents(stats, total) };
}
